import { render, staticRenderFns } from "./my-sa.vue?vue&type=template&id=7efd3848&lang=pug&"
import script from "./my-sa.vue?vue&type=script&lang=js&"
export * from "./my-sa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports